module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "chapter-six"
    }
  }, [_c('div', {
    staticClass: "story"
  }, [_c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" 6")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text-no-indent"
  }, [_c('span', {
    staticClass: "lic"
  }, [_vm._v("“I")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" don’t understand,” I heard Theo say, his voice pained. “Why would that be?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Something was wrong. And on the day we were moving in together—well, not exactly ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("moving in")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("—Theo had decided to buy the place by the Green Door (offering nearly the entire asking price just so he could “avoid all bullshit”), and we figured that Theo might as well stay with me in the short-term since his apartment lease was up.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" And so, a few uneventful days after my meeting with Tatum Reynolds, I left Bristol & Associates a little early and climbed the stairs to the “L” platform, heading home so I could help Theo situate his stuff in my condo. (I was also attempting to make sure he did not situate any of said stuff in places I didn’t want it.) Also, I needed the time to think; to process the fact that someone was moving in with me. I adored Theo, craved him, couldn’t believe how in tune he was with me when we were together, so dialed in, in a way that Sam hadn’t been. It was thrilling. It was scary. But I loved him, I reminded myself. ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Yeah, but you don’t know if he returns the sentiment.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("The “L” train rumbled around the corner at Lake and Wabash, and I moved over for someone to sit next to me.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("No reason for too much analysis, Izzy.")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I reminded myself that Theo and I moving in together was a temporary thing.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" It was a chilly, sunny November day. As I rode the “L,” listening to its wheels screech awkwardly at stops, I let my mind meander into other things. I thought about how I missed my Vespa scooter, which I’d had to retire for the winter. I thought about Thanksgiving coming up in two weeks. I planned to go to my mom and Spence’s place, as I always did. For some reason, Theo and I hadn’t talked about what he was doing. Should I invite him to join? The fact that we were temporarily moving in together already seemed momentous enough.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" When I got home, a nearly empty moving van was out front.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" The numbered keypad outside the front door of the three-flat complex had been disabled by someone with the code; I could tell just by glancing at the display because I had overseen the installation of the keyless entry systems on the front door as well as the door to my condo on the third floor. (Okay, Mayburn had done the overseeing for me while I watched him watch the locksmith.) When it was first installed, we guarded the front-door code like the sphinx. But changing the code frequently quickly got cumbersome. First, my ground-floor neighbor sold his place, requiring visits of about fifty real-estate agents a week. Then my second-floor neighbor decided to rent his condo, and that allowed hordes of apartment hunters to roam the place. And now that Theo was moving in, with his buddies helping him and his moving vans, someone had given up the fight and disabled the keypad altogether. I really couldn’t blame them.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I made my way up the three flights of stairs—the only downside to my condo. When I’d reached the third floor, the door to the apartment was blocked with boxes. I’d managed to stick my head in the door when I heard Theo speak in a strained voice, a voice I’d never heard before. ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“I don’t understand,” ")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" A pause, as Theo listened to whomever he was talking to. “But why?” He sounded distressed. “Why would it be that low?” he continued. “I told you last night, I’ve never bought property before. All I’ve had are two credit cards.” Another pause. “Yeah, well, I guess that could be it but…”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" As his voice died away, some kind of trepidation said hello to my psyche.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “The business has some kind of trust account,” he said. “Could we use that to get credit or cash?” A pause. “No, it’s a foreign trust. I don’t know much about it, but I could…” An exhale. Another moment of silence. “Oh, okay, so then…” Quiet. “Really?” I heard him say. He sounded now not so much distressed, but like a young man surprised at terrible news.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I hated to hear it. I nudged the door to shove aside the boxes and stepped inside.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Theo stood at the bar of my European-style kitchen, his hair pulled back away from his face, wearing an army-green T-shirt and jeans. He turned as I came in. He threw me a polite smile, as if to say, ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("One minute. ")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Or maybe, ")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Everything is fine here. ")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Yet I could tell it wasn’t.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “All right,” he said. “Yeah, talk to you then.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I picked my way through boxes, across the room and gave him a hug. “Who was that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He held me longer than usual. His back muscles felt taut.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I looked up at him. “Everything okay?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" His brow furrowed. “That was Barb. The real- estate agent. She did a pre-application for my mortgage, and it was…” More furrowing. “It was denied.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You’re kidding?” Theo had money. A lot of it, as far as I knew. He and his partner, Eric, started their company—HeadFirst—while in college. HeadFirst’s software allowed people to create their own artistically beautiful websites. The company had performed—")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("over")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("performed—beyond anything anyone expected, according to the frequent press about the company. Theo and Eric had left college and never looked back, walking into a dream life of travel, private planes and a constantly growing business.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" Theo shook his head, still distracted, which was so very unlike his usual life state.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I kept my arms around his back, but I leaned away so I could see him better. “I heard you saying you really hadn’t owned anything yet. Maybe your credit isn’t extensive enough. Especially for the prices you’re looking at.” None of the houses that Theo had viewed had been less than a million dollars, and the one he’d decided upon was almost three times that. “Maybe you need to take out credit cards and then pay them off, that kind of thing?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He shook his head. “She said there should be a high enough credit score, given my income. Also, I’ve had two credit cards, and I always pay them on time. I’ve never been delinquent on any bills.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Well then, what is it? What did she say was bringing your score down?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “She couldn’t tell from the report. She’s going to have her contact at a credit bureau look into it.” The muscles in his back loosened a little, and he let me go, yet his expression remained stiff. “Right now, she said there’s no way I’ll be able to get a mortgage.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Who is this guy? ")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("The thought boomed in my brain without introduction, without warning. And I could feel the question in my body, too—a wariness that took up residence somewhere deep inside and crossed its arms.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("We both looked around my apartment at his stacks of books, piles of boxes, laundry baskets overflowing with jeans and shoes. We both knew that, as we stood there, a new tenant was moving into Theo’s old apartment.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I realized then Theo was staying with me a little longer than I’d thought.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Tick, tick, tick")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" went the silence. It was, I realized, an old clock my mother had given me years ago in college. I’d never noticed the sound before.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You want to go out for a drink?” I said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" He nodded fast.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('br'), _c('br'), _vm._v(" Within fifteen minutes, we were seated at the bar at Topo Gigio, an Italian place on Wells. Thirty minutes after that, we were in high spirits, the owner having sent a bottle of champagne after hearing that we’d just moved in together. Soon, we were making plans for Theo’s condo, drawing game-room and bedroom designs on napkins and searching our phones for photos of furniture he could buy.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Whenever you move to your new place,” I said, “it doesn’t matter.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("“")]), _c('em', {
    staticClass: "italic"
  }, [_vm._v("We ")]), _c('span', {
    staticClass: "generated-style"
  }, [_vm._v("are what matters, right?” Theo said, leaning toward me, moving his bar stool over.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Exactly.” I stared into those eyes, nearly breathless in his presence, the whole of him. Any irrational slices of fear were no longer cutting me.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" An excited look took over Theo’s face. “I just remembered,” he said. “I have a folder of pictures from magazines that I’ve been ripping out. You know, from home magazines?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You’ve been reading home magazines?” I adored him even more, suddenly.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Yeah, well, my mom bought me a bunch of them. And I just remembered. I’ve got pictures of beds, and oh, these kick-ass chairs for a TV room.” He looked so excited then. “Let me run back and get them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “No, let’s just go,” I said, but right then, the bartender delivered the three plates of appetizers we’d ordered.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “It’s a few blocks,” Theo said. He pointed at the appetizers. “You start on these, and I’ll be right back.”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" I watched him walk from the room, watched everyone else stare at him as they always did. As always, he didn’t notice.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “I love you,” I whispered. I was sure about it then, sure that he would return the sentiment. “I love you,” I said, trying the words again. And it was then I decided I would tell him as soon as he came back.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" But a few minutes later, he was calling my phone.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Hey,” I said softly, without having to say another word. Because I felt like every word I would say to Theo now would carry those three words in it.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “We had a break-in,” he said.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" My mouth opened and closed. In front of me, the bartender told an apparently hilarious story, because the two people listening threw their heads back, their mouths open. But I couldn’t hear anything.")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “Back the truck up,” I said into the phone, still trying to meet the anti-swearing campaign goals I’d set last year, despite the situation. “What did you say?”")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v(" “You need to come home,” Theo said. “Someone broke into your place.”")])])])]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })]), _c('a', {
    attrs: {
      "id": "anchor-1-anchor"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15e8c967","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ChapterSix.vue
// module id = 93
// module chunks = 0